import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { NotificationsService } from 'angular4-notifications';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html'
})
export class CompanyProfileComponent implements OnInit {

  	connectedUser: any;
	company: any;
	editProfile: boolean = false;
	formCompany: FormGroup;
  managers: any;
  showAll: boolean = false;
  autocompleteSettings: any = {
    inputPlaceholderText: 'Saisir une adresse',
    showSearchButton: false,
  };
  formErrors: string;
  isLoading: boolean = false;

  @ViewChild('fileInput') fileInput: ElementRef;


  constructor(
  	private http: HttpClient, 
  	private fb: FormBuilder,
    private notificationService: NotificationsService) { }

  ngOnInit() {
  	// Get connected user from local storage
  	this.connectedUser = JSON.parse(localStorage.getItem('currentUser'));
  	this.loadCompany(this.connectedUser.username);
    
  }


  loadCompany(username:string){

  	return this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetCompanyByUsername + username).map((res: Response) => res).subscribe(company => {
      this.company = company;
      this.loadForm();
      this.loadManagers(this.company['managers']);
      console.log(this.company); })
  }

  loadForm(){
  	this.formCompany = this.fb.group({
  		'id' : [this.company['id']],
  		'enabled' : [this.company['enabled']],
  		'password' : [this.company['password']],
    	'roles' : [this.company['roles']],
      'sign_up_date' : [this.company['sign_up_date']],
    	'name' : [this.company['name'], Validators.required],
    	'email' : [this.company['email'], Validators.required],
    	'siret' : [this.company['siret'], Validators.required],
    	'facebook' : [this.company['facebook']],
    	'twitter' : [this.company['twitter']],
    	'street' : [this.company['street'], Validators.required],
    	'streetSecond' : [this.company['street_second']],
    	'postCode' : [this.company['post_code'], Validators.required],
    	'city' : [this.company['city'], Validators.required],
    	'country' : [this.company['country'], Validators.required],
    	'companySize' : [this.company['company_size'], Validators.required],
      'managers' : this.fb.array([this.createManager(this.company['managers'][0])]),
      'logo_url' : [this.company['logo_url']],
      'logo' : null,
      'website' : [this.company['website']],
    });
  }

  loadManagers(managers){
    managers.forEach((manager, index) => {
      if(index > 0){ // First manager already init in loadForm()
        let m = this.createManager(manager);
        this.addManager(m);
      }
    })
  }

  createManager(manager?): FormGroup {
    let group;

    if(manager){
    console.log(manager.firstname);
      group = this.fb.group({
        'id': [manager.id],
        'firstname': [manager.firstname, Validators.required],
        'name': [manager.name, Validators.required],
        'function': [manager.function, Validators.required],
        'email' : [manager.email, Validators.required],
        'phone' : [manager.phone, Validators.required],
        'main_contact' : [manager.main_contact]
      });
    }else{
      group = this.fb.group({
        'id': [null],
        'firstname': [''],
        'name': [''],
        'function': [''],
        'email' : [''],
        'phone' : [''],
        'main_contact' : ['']
      });
    }
    return group;
  }

  addManager(manager?): void {
    const control: FormArray = this.formCompany.get('managers') as FormArray;
    if(manager){
      control.push(manager);
    }else{
      control.push(this.createManager());
    }
  }

  removeManager(index){
    const control: FormArray = this.formCompany.get('managers') as FormArray;
    control.removeAt(index);
  }

  toggleEditProfile(){
  	this.editProfile = this.editProfile === true ? false : true;
  }

  submitProfile(data){

  	if (this.formCompany.valid) {
      this.isLoading = true;

	  	// Get all values from the form
	  	const formModel = this.formCompany.value;
	  	// refresh user to show on edit mode
  		this.company = data;

	    const req = this.http.put(environment.symfonyEndpointSecuredForCompany + environment.apiEditCompany, formModel)
	      .subscribe(
	        res => {
	        	// console.log(res);
	          this.notificationService.success('', 'Modifications sauvegardées');
            this.toggleEditProfile();
            this.showAll = false;
            this.formErrors = '';
            this.isLoading = false;
	        },
	        err => {
            this.isLoading = false;
            if(err.status === 400){
              this.formErrors = JSON.parse(err['error']).message;
            }else{
              this.notificationService.error('Oups', 'Une erreur est survenue.');
              console.error(JSON.parse(err['error']).message);
            }
	        }
	      );
	}else{
    this.isLoading = false;
		this.showAll = true;
    const invalid = [];
      const controls = this.formCompany.controls;
      for (const name in controls) {
         if (controls[name].invalid) {
            console.error(name + ' est invalide.');
         }
      }
	}

  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.formCompany.get('logo').setValue({
          filename: this.company.id + '-' + file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.formCompany.get('logo_url').setValue(this.company.id + '-' + file.name);
      };
    }
  }

  autoCompleteAddress(selectedData:any) {
    for (var i in selectedData.data.address_components) {
      var component = selectedData.data.address_components[i];
      for (var j in component.types) {  // Some types are ["country", "political"]
        var type_element = component.types[j];
        switch (type_element) {
          case "street_number":
            this.formCompany.get('street').setValue(component.long_name);
            break;
          case "route":
            this.formCompany.get('street').setValue(this.formCompany.get('street').value + ' ' + component.long_name);
            break;
          case "postal_code":
            this.formCompany.get('postCode').setValue(component.long_name);
            break;
          case "locality":
            this.formCompany.get('city').setValue(component.long_name);
            break;
          
          default:
            // code...
            break;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/company/company-profile/company-profile.component.ts